module.exports = __webpack_public_path__ + "784ce4e5.svg";